module.exports = __webpack_public_path__ + "img/one-page-plan.936a2976.svg";